import React , { useCallback,useEffect,useState,useContext,useRef } from 'react';
import { Input,Card,Table,Slider,Spin,Radio,Modal,Button,message,Select,InputNumber,Popover,Space,Col,Row} from 'antd';

const LeagueSearchCard= (props) => {
    const { setDraftType, draftType,
        setTESearch, TESearch,
        setQBSearch, QBSearch,
        setWRSearch, WRSearch,
        setTeamsSearch, teamsSearch,
        setFilterAfterNflDraft,filterAfterNflDraft
    } = props;
  
    const QBoptions = [
        { label: 'SuperFlex/2QB', value: 'SuperFlex/2QB' },
        { label: 'SingleQB', value: 'SingleQB' }
      ];
    
      const WRoptions = [
        { label: 'Either', value: 'Either' },
        { label: '2WR', value: '2WR' },
        { label: '3WR', value: '3WR' }
      ];
    
      const TEoptions = [
        { label: 'Either', value: 'Either' },
        { label: 'TE Premium', value: 'Yes'},
        { label: 'Non - TE Premium', value: 'No' }
      ];
    
      const draftTypeOptions = [
        { label: 'Veteran', value: 'vet' },
        { label: 'Rookie', value: 'rookie' }
      ];

      const afterNflDraftTypeOptions = [
        { label: 'Yes', value: true },
        { label: 'No', value: false }
      ];
    
  const onQBChange = ({ target: { value } }) => {
    console.log('QB Search checked', value);
    setQBSearch(value);

  };

  const onWRChange = ({ target: { value } }) => {
    console.log('WR Search checked', value);
    setWRSearch(value);

  };

  const onDraftTypeChange = ({ target: { value } }) => {
    console.log('WR Search checked', value);
    setDraftType(value);

  };

  const onTEChange = ({ target: { value } }) => {
    console.log('TE Search checked', value);
    setTESearch(value);

  };

  const onFilterAfterNflDraftChange = ({ target: { value } }) => {
    console.log('onFilterAfterNflDraftChange', value);
    setFilterAfterNflDraft(value);

  };



  const onTeamsChange = ({ target: { value } }) => {
    console.log('teamsSearch checked', value);
    setTeamsSearch(value);
  
  };
  
    return (
        <Card style={{border:'3px'}}
        title="Filters"
        >
    <Row>
    <Col style={{width:'15%'}}>
    <div>Draft Type:</div>
   <Radio.Group
   style={{width:'100%'}}
   onChange={onDraftTypeChange}
   value={draftType}
   optionType="button"
   options={draftTypeOptions}/>
   </Col>
   <Col style={{width:'20%'}}>
   <div>QB Type:</div>
 <Radio.Group
   onChange={onQBChange}
   value={QBSearch}
   optionType="button"
   options={QBoptions}/>
</Col>
<Col style={{width:'25%'}}>
<div>TE Premium:</div>
 <Radio.Group
   onChange={onTEChange}
   value={TESearch}
   optionType="button"
   options={TEoptions}/>
</Col>
<Col style={{width:'20%'}}>
<div>WR Starters:</div>
 <Radio.Group
   onChange={onWRChange}
   value={WRSearch}
   optionType="button"
   options={WRoptions}/>
   </Col>
   <Col style={{width:'20%'}}>
<div>Filter Post NFL Draft:</div>
 <Radio.Group
   onChange={onFilterAfterNflDraftChange}
   value={filterAfterNflDraft}
   optionType="button"
   options={afterNflDraftTypeOptions}/>
</Col>
 </Row>
 
 </Card>
    );
  };

export default LeagueSearchCard;
